import React from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Dots(props) {
  var {
    prefixCls,
    data,
    step,
    min,
    vertical,
    marks,
    markRender
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: prefixCls + "-dots",
    children: data.map((val, idx) => {
      var stepValue = idx * step + min;
      return /*#__PURE__*/_jsxs("div", {
        style: {
          [vertical ? 'top' : 'left']: val + "%"
        },
        className: [prefixCls + "-mark", marks && marks !== true && !marks[stepValue] ? 'no-marks' : null].filter(Boolean).join(' ').trim(),
        children: [marks === true && markRender && markRender(stepValue), marks !== true && marks && marks[stepValue] && markRender && markRender(stepValue, marks[stepValue])]
      }, idx);
    })
  });
}